module.exports = __webpack_public_path__ + "img/result_share.7f62688c.png";